<template>
  <div class="p-front__content">
    <!-- {{ regSuccess }} -->
    <div class="p-signup" style="vertical-align:middle">
      <form class="p-signup__form" v-if="!regSuccess" action="#" @submit.prevent="submitRequest">
        <img class="p-signin-a__form-heading" src="https://arnergy.com/logo.png" alt height="50px;" />
        <h4 class="p-signup__form-heading">Reset Password</h4>
        <div class="p-signup__form-content">
          <b-alert variant="danger" dismissible :show="displayError">{{ errorMessage }}</b-alert>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-set-password">Set Password</label>
              <input
                type="password"
                class="form-control form-control-lg"
                id="p-signup-set-password"
                placeholder="Password "
                v-model="regParams.newPassword"
              />
            </div>
            <div class="form-group col-md-12">
              <label for="p-signup-repeat-password">Repeat Password</label>
              <input
                type="password"
                class="form-control form-control-lg"
                id="p-signup-repeat-password"
                placeholder="Repeat Password "
                v-model="cpassword"
              />
            </div>
          </div>
          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg p-signup__form-submit"
              @click="submitRequest"
            >CONTINUE</button>
          </div>
        </div>
      </form>
      <div v-if="regSuccess" class="p-signup__form" style="text-align:center">
        <span class="fa fa-key fa-fw" style="font-size:12em; color:#192a3e; margin-top: 20px;"></span>
        <div
          class="p-signup__form-content"
          style="font-size:14px; color:#192a3e;  text-align:center"
        >
          <h4>Your password has been reset!</h4>

          <router-link class="link-info" to="/auth/login">
            <button class="btn btn-info btn-block btn-lg p-signup__form-submit">LOGIN</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
// import { VueNotifications } from '../../main';
import axios from "axios";

export default {
  name: "register",
  data() {
    return {
      regSuccess: false,
      cpassword: null,
      regParams: {
        newPassword: null,
        accessToken: null,
        userId: null
      },
      errors: {},
      displayError: false,
      errorMessage: ""
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        // console.log(`${field}: ${value}`);
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "newPassword":
            if (value === "null" || value === "") {
              errors[field] = "Password cannot be empty.";
            } else if (value !== this.cpassword) {
              errors[field] = "Password did not match.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = errors;
    },
    submitRequest() {
      this.validateReg();
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({ message: errorMsg });
      } else {
        var str = JSON.stringify(this.regParams);
        const tempReg = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const url = "/users/update-password-from-token";
        HTTP.post(`${url}?access_token=${this.$route.params.token}`, tempReg)
          .then(response => {
            container.regSuccess = true;
          })
          .catch(error => {
            var errorMsg = error.response.data.error.message;
            this.showErrorMsg({ message: errorMsg });
          });
      }
    }
  },
  mounted() {
    this.regParams.userId = this.$route.params.uid;
    // this.regParams.accessToken = this.$route.params.token;
  }
};
</script>
<style  scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #6a707e;
  border: none;
  margin: 10px 0;
}
.p-signin-a__form-heading {
  margin: 30px 180px;
}
#reg_success {
  position: absolute;
  /* height: 100vh; */
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}

.p-signup__form-submit {
  margin-bottom: 20px;
}
input[type="password"] {
  background-image: url("../../assets/img/key2.png");
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
.p-signup__form-submit .link-info {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/NewPassword.vue